<style>
.error--text{
  color:red!important;
}

.error{
  color:darkred!important;
}
</style>
<template>

    <div>

      <template v-if="isLoading">
        <loading :active.sync="isLoading"
                 :can-cancel="true"
                 :on-cancel="onCancel"
                 :is-full-page="fullPage"></loading>

      </template>
      <div class="alert alert-danger" role="alert" v-if="errors.pp" ref="pp_error">
        <strong>Whoops!</strong> Please accept privacy policy.
      </div>

      <div class="alert alert-danger" role="alert" v-if="errors.login_email">
        <strong>Whoops!</strong> Please enter a valid email address.
      </div>

      <div class="alert alert-danger" role="alert" v-if="errors.email_not_found">
        <strong>Whoops!</strong> Email not found
      </div>


      <v-form>
      <v-card ref="form">
        <v-tabs
            v-model="tab"
            centered

            icons-and-text
        >
          <v-tabs-slider></v-tabs-slider>

          <v-tab href="#tab-1">
            Register
            <v-icon>mdi-phone</v-icon>
          </v-tab>

          <v-tab href="#tab-2">
            Login
            <v-icon>mdi-heart</v-icon>
          </v-tab>


        </v-tabs>

        <v-tabs-items v-model="tab">
          <v-tab-item
              value="tab-1"
          >

            <v-container>
              <v-row>
                <v-col cols="12" sm="12">
                  <p>Data protection is changing rapidly — be on the edge of what’s next. Veeam Live will give you actionable Cloud Data Management™ guidance and help you propel your business forward.</p>
                  <p>  Are you ready to up your data protection game?</p>
                </v-col>
              </v-row>
            </v-container>

              <v-container>
                <v-row>
                  <v-col cols="12" sm="12">
                    <v-text-field
                        ref="first_name"
                        label="First Name"
                        hint="Required"
                        v-model="formData.first_name"
                        persistent-hint
                        :rules="[() => !! formData.first_name || 'This field is required']"
                        :error-messages="errorMessages"
                        required
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="12">
                    <v-text-field
                        ref="last_name"

                        label="Last Name"
                        hint="Required"
                        v-model="formData.last_name"
                        persistent-hint
                        :rules="[() => !! formData.last_name || 'This field is required']"
                        :error-messages="errorMessages"
                        required
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="12">
                    <v-text-field
                        ref="email"

                        label="Business Email"
                        hint="Required"
                        persistent-hint
                        v-model="formData.email"
                        :rules="[() => !! formData.email || 'This field is required']"
                        :error-messages="errorMessages"
                        required

                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="12">
                    <v-text-field
                        label="Company"
                        hint="Required"
                        persistent-hint
                        v-model="formData.company"

                        ref="company"
                        :rules="[() => !! formData.company || 'This field is required']"
                        :error-messages="errorMessages"
                        required

                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="12">
                    <v-text-field
                        label="Job Title"
                        hint="Required"
                        persistent-hint
                        v-model="formData.job_title"

                        ref="job_title"
                        :rules="[() => !! formData.job_title || 'This field is required']"
                        :error-messages="errorMessages"
                        required

                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="12" data-app>
                    <v-select
                        :items="['Customer','Partner','Potential Customer','Employee']"
                        label="Veeam Business Relationship"
                        hint="Required"
                        persistent-hint
                        v-model="formData.business_relationship"

                        ref="business_relationship"
                        :rules="[() => !! formData.business_relationship || 'This field is required']"
                        :error-messages="errorMessages"
                        required


                    ></v-select>
                  </v-col>

                  <v-col cols="12" sm="12" data-app>
                    <v-select
                        :items="country_list"
                        label="Country"
                        hint="Required"
                        persistent-hint
                        v-model="formData.country"

                        ref="country"
                        :rules="[() => !! formData.country || 'This field is required']"
                        :error-messages="errorMessages"
                        required

                    ></v-select>
                  </v-col>

                  <v-col cols="12" sm="12" data-app v-if="condition">
                    <v-text-field
                        label="Email of person that referred you"

                        v-model="formData.email_of_person_that_referred_you"

                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="12" data-app v-if="formData.business_relationship == 'Customer'">

<!--                    <v-select-->
<!--                        :items="fields[11].values"-->
<!--                        label="Which of the following Veeam products do you use?"-->
<!--                        v-model="formData.which_veeam_products_do_you_use"-->

<!--                    ></v-select>-->

                    <label class="typo__label">Which of the following Veeam products do you use?</label>

                    <multiselect :multiple="true" v-model="formData.which_veeam_products_do_you_use" :options="fields[11].values"></multiselect>



                  </v-col>

                  <v-col cols="12" sm="12" data-app v-if="condition">

                    <v-select
                        :items="['Executive Officer','Department Manager/ Manager','Specialist','Consultant','Student','Other']"
                        label="What is your role at your company ?"
                        persistent-hint
                        v-model="formData.role_at_company"

                    ></v-select>
                  </v-col>

                  <v-col cols="12" sm="12" data-app v-if="formData.role_at_company == 'Other'">
                    <v-text-field
                        label="Role at Company, if 'Other'"

                        v-model="formData.role_at_company_others"

                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="12" data-app v-if="condition">
                    <v-select
                        :items="['< 100 ','100-500','500-1,000','1,000-5,000','5,000-10,000','10,000+']"
                        label="Approximately how many employees work at your company?"
                        v-model="formData.employees_at_company"

                    ></v-select>
                  </v-col>

                  <v-col cols="12" sm="12" data-app v-if="condition">
                    <v-select
                        :items="fields[8].values"
                        label="What is primary industry of your company?"
                        v-model="formData.industry_of_company"

                    ></v-select>
                  </v-col>

                  <v-col cols="12" sm="12" data-app v-if="formData.industry_of_company == 'Other'">
                    <v-text-field
                        label="Primary Industry, if 'Other'"

                          v-model="formData.industry_of_company_others"

                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="12" data-app v-if="condition">
                    <v-select
                        :items="fields[1].values"
                        label="Veeam is donating $1 for every Veeam Live registration. Where would you like the $1 for your registration to be donated"
                        v-model="formData.veeam_is_donating"

                    ></v-select>
                  </v-col>



                </v-row>

                <v-row>
                  <v-col cols="12" sm="12">
                    <label><input type="checkbox"  v-model="formData.register_receive_newsletter"
                    > &nbsp;&nbsp; Yes, I want to receive communications about Veeam products, services, and events. I can unsubscribe at any time.</label>


                  </v-col>

                  <v-col cols="12" sm="12">
                    <label v-bind:class="[errors.pp ? classes.errors : '']"><input type="checkbox"  v-model="formData.register_privacy_policy"
                    > &nbsp;&nbsp; I agree that my personal data will be managed by Veeam in accordance with the <a href="https://www.veeam.com/privacy-policy.html">Privacy Policy.</a></label>


                  </v-col>
                </v-row>
              </v-container>

              <v-container>
                <input type="button" value="Submit" class="btn btn-success" @click="submitForm" >

              </v-container>

          </v-tab-item>


          <v-tab-item
              value="tab-2"
          >

            <v-container>
              <v-row>
                <v-col cols="12" sm="12">
                  <p>Get ready to up your data protection game and be on the edge of what’s next in Cloud Data Management™.</p>

                    <p>Enter in the email address used to register and click “Login” below to start your Veeam Live journey.</p>
                </v-col>
              </v-row>
            </v-container>

            <v-container>
              <v-row>
                <v-col cols="12" sm="12">
                  <v-text-field
                      label="Email"
                      hint="Required"
                      v-model="LoginForm.email"
                      persistent-hint
                  ></v-text-field>
                </v-col>
              </v-row>



            </v-container>


            <v-container>
              <input type="button" value="Login" class="btn btn-success" @click="loginForm" >

            </v-container>
          </v-tab-item>


        </v-tabs-items>
      </v-card>

      </v-form>
    </div>


</template>

<script>

// import textBox  from "@/components/form/controls/textBox";
import store from '../../store'

import axios from 'axios'
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
import Multiselect from 'vue-multiselect'


export default {

  props: ['label', 'placeholder'],

  components: {
    Loading,
    Multiselect
  },
  data() {
    return {

      isLoading: false,
      fullPage: true,

      // eventId : '243526',
      // ticketId: '150158',

      //Live
      eventId : '237853',
      ticketId: '146981',



      items: ['Foo', 'Bar', 'Fizz', 'Buzz'],
      country_list : ["Afghanistan",
        "Albania",
        "Algeria",
        "Andorra",
        "Angola",
        "Antigua and Barbuda",
        "Argentina",
        "Armenia",
        "Australia",
        "Austria",
        "Azerbaijan",
        "Bahamas",
        "Bahrain",
        "Bangladesh",
        "Barbados",
        "Belarus",
        "Belgium",
        "Belize",
        "Benin",
        "Bhutan",
        "Bolivia",
        "Bosnia and Herzegovina",
        "Botswana",
        "Brazil",
        "Brunei",
        "Bulgaria",
        "Burkina Faso",
        "Burundi",
        "Cambodia",
        "Cameroon",
        "Canada",
        "Cape Verde",
        "Central African Republic",
        "Chad",
        "Chile",
        "China",
        "Colombi",
        "Comoros",
        "Congo (Brazzaville)",
        "Congo",
        "Costa Rica",
        "Cote d'Ivoire",
        "Croatia",
        "Cuba",
        "Cyprus",
        "Czech Republic",
        "Denmark",
        "Djibouti",
        "Dominica",
        "Dominican Republic",
        "East Timor (Timor Timur)",
        "Ecuador",
        "Egypt",
        "El Salvador",
        "Equatorial Guinea",
        "Eritrea",
        "Estonia",
        "Ethiopia",
        "Fiji",
        "Finland",
        "France",
        "Gabon",
        "Gambia, The",
        "Georgia",
        "Germany",
        "Ghana",
        "Greece",
        "Grenada",
        "Guatemala",
        "Guinea",
        "Guinea-Bissau",
        "Guyana",
        "Haiti",
        "Honduras",
        "Hungary",
        "Iceland",
        "India",
        "Indonesia",
        "Iran",
        "Iraq",
        "Ireland",
        "Israel",
        "Italy",
        "Jamaica",
        "Japan",
        "Jordan",
        "Kazakhstan",
        "Kenya",
        "Kiribati",
        "Korea, North",
        "Korea, South",
        "Kuwait",
        "Kyrgyzstan",
        "Laos",
        "Latvia",
        "Lebanon",
        "Lesotho",
        "Liberia",
        "Libya",
        "Liechtenstein",
        "Lithuania",
        "Luxembourg",
        "Macedonia",
        "Madagascar",
        "Malawi",
        "Malaysia",
        "Maldives",
        "Mali",
        "Malta",
        "Marshall Islands",
        "Mauritania",
        "Mauritius",
        "Mexico",
        "Micronesia",
        "Moldova",
        "Monaco",
        "Mongolia",
        "Morocco",
        "Mozambique",
        "Myanmar",
        "Namibia",
        "Nauru",
        "Nepal",
        "Netherlands",
        "New Zealand",
        "Nicaragua",
        "Niger",
        "Nigeria",
        "Norway",
        "Oman",
        "Pakistan",
        "Palau",
        "Panama",
        "Papua New Guinea",
        "Paraguay",
        "Peru",
        "Philippines",
        "Poland",
        "Portugal",
        "Qatar",
        "Romania",
        "Russia",
        "Rwanda",
        "Saint Kitts and Nevis",
        "Saint Lucia",
        "Saint Vincent",
        "Samoa",
        "San Marino",
        "Sao Tome and Principe",
        "Saudi Arabia",
        "Senegal",
        "Serbia and Montenegro",
        "Seychelles",
        "Sierra Leone",
        "Singapore",
        "Slovakia",
        "Slovenia",
        "Solomon Islands",
        "Somalia",
        "South Africa",
        "Spain",
        "Sri Lanka",
        "Sudan",
        "Suriname",
        "Swaziland",
        "Sweden",
        "Switzerland",
        "Syria",
        "Taiwan",
        "Tajikistan",
        "Tanzania",
        "Thailand",
        "Togo",
        "Tonga",
        "Trinidad and Tobago",
        "Tunisia",
        "Turkey",
        "Turkmenistan",
        "Tuvalu",
        "Uganda",
        "Ukraine",
        "United Arab Emirates",
        "United Kingdom",
        "United States",
        "Uruguay",
        "Uzbekistan",
        "Vanuatu",
        "Vatican City",
        "Venezuela",
        "Vietnam",
        "Yemen",
        "Zambia",
        "Zimbabwe"],

      fields: [],
      formData: {
        first_name:'',
        last_name:'',
        email:'',
        company:'',
        job_title:'',
        country:'',
        business_relationship:'',

        register_receive_newsletter:false,
        login_receive_newsletter:false,
        register_privacy_policy:false,

        ticketId: null
      },

      LoginForm:{
        email:''
      },

      errors:{
        pp:false,
        login_email:false,
        email_not_found:false,
      },



      tab: null,

      errorMessages: '',
      formHasErrors: false,

      classes:{
        errors:'error'
      }


    }


  },

  watch: {
    first_name () {
      this.errorMessages = ''
    },
  },


  computed: {
    condition() {
      let relationship = this.formData.business_relationship


      if(relationship == 'Customer' || relationship == 'Partner' || relationship == 'Potential Customer')
        return true;
      else
        return false;
    },

    form () {
      return {
        first_name: this.formData.first_name,
        last_name: this.formData.last_name,
        email: this.formData.email,
        company: this.formData.company,
        job_title: this.formData.job_title,
        country: this.formData.country,
        business_relationship: this.formData.business_relationship,

      }
    },
  },
  created() {
    let config = {
      headers: {
        Accept : ' application/vnd.bizzabo.v2.0+json'
      }
    }

    let ref= this
    axios.get('https://gc.bhmlabs.ca/api/reg_types',config).then(function (response) {

      ref.fields = response.data.content[0].registrationProperties
      console.log(response.data.content[0].registrationProperties)

    })


  } ,

  methods:{


    formValidate(){

      if(this.formData.register_privacy_policy === false){
        return false;
      }
    },

    addToLocal(magicLink,ticketId,id){

      localStorage.setItem('magicLink', magicLink);
      localStorage.setItem('ticketId', ticketId);
      localStorage.setItem('ticketNumber', id);
    },
    submitForm(){


      this.formHasErrors=false

      Object.keys(this.form).forEach(f => {
        if (!this.form[f]) this.formHasErrors = true

        this.$refs[f].validate(true)
      })

      if(this.formHasErrors){
        return;
      }

      if(!this.formData.register_privacy_policy){
        this.errors.pp=true


        return;
      }






      this.isLoading=true

      let ref= this

      let payload= {
        properties:{
          'firstName' : ref.formData.first_name,
          'lastName' : ref.formData.last_name,
          'email' : ref.formData.email,
          'company': ref.formData.company,
          'country' : ref.formData.country,
          'veeam_business_relat' : ref.formData.business_relationship,
          'approximately_how_ma': ref.formData.employees_at_company,
          'what_is_the_primary_': ref.formData.industry_of_company,
          'which_of_the_followi': ref.formData.which_veeam_products_do_you_use,
          'title': ref.formData.job_title,
          'role_at_your_company': ref.formData.role_at_company_others,
          'what_is_your_role_at': ref.formData.role_at_company,
          'veeam_is_donating_1_1': ref.formData.veeam_is_donating,
          'email_of_person_that': ref.formData.email_of_person_that_referred_you
        },

        ticketId : this.ticketId
      }


      axios.post(`https://gc.bhmlabs.ca/api/reg?eventId=${this.eventId}&ticketId=${this.ticketId}`,payload, {
        headers: {
          'Accept' : 'application/vnd.bizzabo.v2.0+json',
          'Access-Control-Allow-Origin':'*'
        }}).then(response=> {

        console.log(response.data)
        this.formData.ticketId = response.data.ticketId

        this.addToLocal(response.data.magicLink, response.data.ticketId, response.data.id)

        if(Object.prototype.hasOwnProperty.call(this.formData, "which_veeam_products_do_you_use")){
          this.formData.which_veeam_products_do_you_use = this.formData.which_veeam_products_do_you_use.join()
        }

        axios.post('https://gc.bhmlabs.ca/api/db',JSON.stringify(this.formData)).then(response=>{
          console.log(response.data.user_id)

          localStorage.setItem('user_id', response.data.user_id);

          this.isLoading=false

          // axios.get(response.data.magicLink).then(response => {
          //   console.log(response.data)
          //   window.location.reload()
          //
          // })


          window.location.reload()
          console.log(this.formData)

          store.commit('toggle_isSubmitted',true)


        })


      });




    },


    loginForm(){


      if(this.LoginForm.email == ''){
        this.errors.login_email=true;

        return;
      }

      this.isLoading=true



        axios.get(`https://gc.bhmlabs.ca/api/login?eventId=${this.eventId}&email=${this.LoginForm.email}`).then(response=> {
       // console.log(response.data.content[0].magicLink)


        let total_elements = response.data.page.totalElements

        if(total_elements == 0){
            this.errors.email_not_found=true
            this.isLoading=false

            return;

        }

        this.addToLocal(response.data.content[0].magicLink, response.data.content[0].ticketId,response.data.content[0].id)


        store.commit('toggle_isSubmitted',true)
        this.isLoading=false



        if(response.data.content[0].magicLink !== undefined && response.data.content[0].ticketId !== undefined ){

          // //  window.open(response.data.content[0].magicLink)
            window.location.reload()

          // axios.get(response.data.magicLink).then(response => {
          //   console.log(response.data)
          //   window.location.reload()
          //
          // })



        }




      });



    }
  }
}

</script>


<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>


<style scoped>

  form {
    padding: 10px;
    width: 100%;
    display: flex;
    flex-direction: column;
    font-family: guardianfont;
  }

  .innerform {
    padding: 5px;
  }





</style>